module.exports = __webpack_public_path__ + "img/right-icon.f83b989a.svg";